import styled from 'styled-components';

export const CatalogStepContainer = styled.div`
  flex: 1;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 24px;
`;

export const Illustration = styled.img`
  width: 160px;
  height: auto;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 8px;

  text-align: center;
`;

export const ChoicesContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
`;

export const ChoiceLabel = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

// Wraps the radio button tightly so that the hover halo below matches its round shape. The
// transition mirrors the one of the library Button so both hover effects land at the same time
export const RadioHoverArea = styled.div`
  display: flex;

  border-radius: 50%;

  transition: background 0.2s ease-in;
`;

/**
 * The library RadioButton only highlights itself when hovered directly. This wrapper replicates its
 * halo behind the radio as soon as the pointer is anywhere on the surrounding choice button.
 */
export const ChoiceButtonContainer = styled.div`
  &:hover ${RadioHoverArea} {
    background: ${({ theme }) => theme.radioButton.hover.backgroundColor};
  }
`;
